import type { CaseInfo } from '../CaseInfoApi';

export interface UserPermissions {
  canApproveCase: boolean;
  canRejectCase: boolean;
  canProceedCase: boolean;
  canSaveCase: boolean;
}

export class CaseState {
  public readonly userPermissions: UserPermissions;

  public readonly caseCode: string;

  public readonly surgeryType: string;

  public readonly surgeryTypeName: string;

  public readonly caseDetailsUrl: string;

  public constructor(caseInfo: CaseInfo) {
    this.userPermissions = {
      canApproveCase: caseInfo.canApproveCase,
      canRejectCase: caseInfo.canRejectCase,
      canProceedCase: caseInfo.canProceedCase,
      canSaveCase: caseInfo.canSaveCase
    };
    this.caseCode = caseInfo.caseCode;
    this.surgeryType = caseInfo.surgeryType;
    this.surgeryTypeName = caseInfo.surgeryTypeName;
    this.caseDetailsUrl = caseInfo.caseDetailsUrl;
  }
}
